"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidFormat = exports.isValidMask = exports.isValid = exports.getData = void 0;
const axios_1 = __importDefault(require("axios"));
const webservice = 'https://servicodados.ibge.gov.br/api/v2/cnae/subclasses/#VAL#';
async function getData(value) {
    if (typeof value !== 'string' || /\D/.test(value))
        return false;
    try {
        const url = webservice.replace('#VAL#', value);
        const response = await axios_1.default.get(url);
        if (response.data.length >= 1)
            return true;
        return false;
    }
    catch (error) {
        return false;
    }
}
exports.getData = getData;
async function isValid(value) {
    const response = await getData(value);
    return response;
}
exports.isValid = isValid;
async function isValidFormat(value) {
    if (typeof value !== 'string' || /\D/.test(value))
        return false;
    return /^\d{7}$/.test(value);
}
exports.isValidFormat = isValidFormat;
function isValidMask(value) {
    if (typeof value !== 'string')
        return false;
    return /^\d{4}-\d{1}\/\d{2}$/.test(value);
}
exports.isValidMask = isValidMask;
//# sourceMappingURL=cnae.js.map